<div class="app" [ngClass]="{'is-folded': isExpanded == false}">
  <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>
